define('Amasty_Conditions/js/model/subscriber',[
    'ko'
    ], function (ko) {
        return {
            isLoading: ko.observable(false)
        }
    }
);
